import { FormType } from '../../../form-types';
import { MigraineQuestionFieldAnswers } from '../questions';

export const migraineCommon: FormType<MigraineQuestionFieldAnswers> = {
  name: 'Migraine Common Questions',
  questions: [
    {
      key: 'migraine_safetyAcknowledgment',
      next: {
        condition: { 'migraine_safetyAcknowledgment.do_not_continue': true },
        key: 'generic_didNotConsent',
        els: 'migraine_sexAssignedAtBirth'
      }
    },
    {
      key: 'migraine_sexAssignedAtBirth',
      next: {
        condition: { 'migraine_sexAssignedAtBirth.female': true },
        key: 'migraine_pregnancyStatus',
        els: 'migraine_diagnosedMigraine'
      }
    },
    {
      key: 'migraine_pregnancyStatus',
      next: {
        condition: { 'migraine_pregnancyStatus.yes': true },
        key: 'generic_ineligible',
        els: 'migraine_consentPregnancy'
      }
    },
    {
      key: 'migraine_consentPregnancy',
      next: {
        condition: { 'migraine_consentPregnancy.do_not_proceed': true },
        key: 'generic_didNotConsent',
        els: 'migraine_diagnosedMigraine'
      }
    },
    {
      key: 'migraine_diagnosedMigraine',
      next: {
        condition: { 'migraine_diagnosedMigraine.no': true },
        key: 'generic_ineligible',
        els: 'migraine_usualMigrainePattern'
      }
    },
    {
      key: 'migraine_usualMigrainePattern',
      next: {
        condition: { 'migraine_usualMigrainePattern.different': true },
        key: 'generic_ineligible',
        els: 'migraine_hemiplegicOrBrainstemAura'
      }
    },
    {
      key: 'migraine_hemiplegicOrBrainstemAura',
      next: {
        condition: { 'migraine_hemiplegicOrBrainstemAura.yes': true },
        key: 'generic_ineligible',
        els: 'migraine_redFlagSymptoms'
      }
    },
    {
      key: 'migraine_redFlagSymptoms',
      next: {
        switch: [
          {
            condition: { 'migraine_redFlagSymptoms.new_weakness': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.trouble_speaking': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.numbness_tingling': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.confusion': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.seizure': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.vision_changes': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.worst_headache': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.thunderclap': true },
            key: 'generic_ineligible'
          },
          {
            condition: {
              'migraine_redFlagSymptoms.worsening_or_prolonged': true
            },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.exertion_triggered': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.immunocompromised': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.recent_trauma': true },
            key: 'generic_ineligible'
          },
          {
            condition: {
              'migraine_redFlagSymptoms.fever_neck_stiffness': true
            },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.new_rash': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.scalp_jaw_pain': true },
            key: 'generic_ineligible'
          },
          {
            condition: { 'migraine_redFlagSymptoms.blood_thinners': true },
            key: 'generic_ineligible'
          }
        ],
        els: 'migraine_headacheOnset'
      }
    },
    {
      key: 'migraine_headacheOnset',
      next: {
        condition: { 'migraine_headacheOnset.more_than_72_hours': true },
        key: 'generic_ineligible',
        els: 'migraine_painLocation'
      }
    },
    {
      key: 'migraine_painLocation',
      next: {
        condition: { 'migraine_painLocation.other': true },
        key: 'migraine_painLocationOther',
        els: 'migraine_aura'
      }
    },
    'migraine_painLocationOther',
    'migraine_aura',
    {
      key: 'migraine_triggers',
      next: {
        condition: { 'migraine_triggers.other': true },
        key: 'migraine_triggersOther',
        els: 'migraine_acuteMedFrequency'
      }
    },
    'migraine_triggersOther',
    'migraine_acuteMedFrequency'
  ]
};
